import Dashboard from './Layout/Dashboard/dashboard'
import { BrowserRouter, Switch, Route, useHistory, Redirect, useLocation} from 'react-router-dom'
import { useEffect, useState } from 'react'
import EventContext from './eventContext'
import { handleEventLogs } from './events'

import './sass/custom.scss'
import ToastMessage from 'components/shared/ToastMessage'
import { connect, useDispatch } from 'react-redux'
import {SET_TOKEN,SET_ROLLNO,SET_DOB,SET_TOAST_DATA} from 'constants/actionTypes'
import { usePutPostApi } from 'api/usePutPostApi'
import config from 'config'
import {extractQueryParams,filterParamsStartingWithUtm} from 'utils/getAllURLParameters'
import { authRoutes, publicRoutes, scholarshipRoutes } from 'routes'
import { setExamType } from 'reducers/examTypeReducer'
import { getExamType } from 'utils/common'
import Loader from 'components/Loader/Loader'

const mapStateToProps = (state) => ({
  toastData: state.toastMsgs,
  token: state?.token,
})

const mapDispatchToProps = (dispatch) => ({
  setToken: (payload) => dispatch({ type: SET_TOKEN, payload }),
  setRollNo: (payload) => dispatch({ type: SET_ROLLNO, payload }),
  setDOB: (payload) => dispatch({ type: SET_DOB, payload }),
  setToastMsgsData: (payload) => {
    dispatch({ type: SET_TOAST_DATA, payload })
  },
})

const App = (props) => {
  // Auto Login
  const location = useLocation()

  const history = useHistory()
  const [rollno, setRollno] = useState('')
  const [dob, setDob] = useState('')
  const queryParams = new URLSearchParams(location.search)
  const registration = queryParams.get('registeration')
  const registration_status = queryParams.get('status')

  const [isLoading, setIsLoading] = useState(true)

  const { data, loading, setPutEnabled } = usePutPostApi(config.LOGIN_API, '', 'post', { roll_number: rollno, date_of_birth: dob }, false)

  const queryString = window.location.search

  const dispatch = useDispatch()

  useEffect(() => {
      const examType = getExamType()
      dispatch(setExamType(examType))
  }, [dispatch])

    useEffect(() => {
        // auto-login
        let parameters = {}

        const queryParamsArray = queryString.replace('?', '').split(/&|=/)
        parameters = extractQueryParams(queryParamsArray)

        if (
            !queryParamsArray.includes('roll_no') &&
            !queryParamsArray.includes('dob') &&
            !queryParamsArray.includes('status') &&
            props.token !== null
        )
            history.replace('/dashboard')
        else if (
            !queryParamsArray.includes('roll_no') &&
            !queryParamsArray.includes('dob') &&
            props.token === null
        )
            props.setToken(null)

        if (queryParamsArray.includes('roll_no')) {
            setRollno(parameters['roll_no'])
        }

        // Auto login
        if (parameters['roll_no'] && parameters['dob'] && parameters['registeration'] != 'success') {
            setRollno(parameters['roll_no'])
            setDob(parameters['dob'])
            setPutEnabled(true)
        } else setIsLoading(loading)

        const utmParameters = filterParamsStartingWithUtm(parameters)
        localStorage.setItem('utmParams', JSON.stringify(utmParameters))
        if (parameters['gclid']) {
            localStorage.setItem('gclid', parameters['gclid'])
        }

    }, [])

    useEffect(() => {
        if (data && data.success === 'true') {
            props.setToken(data.token)
            props.setRollNo(rollno)
            props.setDOB(dob)

            history.push({
                pathname: '/dashboard',
            })
            setIsLoading(false)
        } else if (data && data.success === 'false') {
            props.setToastMsgsData({
                isToastOpen: true,
                toastType: 'danger',
                toastMessage: data?.msg || 'Something went wrong.',
            })
            setIsLoading(false)
        }

        // eslint-disable-next-line
    }, [data])

  useEffect(() => {
      let timer
      if (props.toastData.isToastOpen)
          timer = setTimeout(
              () => {
                  props.setToastMsgsData({
                      isToastOpen: false,
                      toastMessage: '',
                  })
              },
              props.toastData.toastType === 'warn' ? 1500 : 5000,
          )

      return () => {
          clearTimeout(timer)
      }

      // eslint-disable-next-line
  }, [props.toastData.isToastOpen])

  useEffect(() => {
      // document.addEventListener("contextmenu", (event) => {
      //     alert("Right click is disabled for this site");
      //     event.preventDefault();
      //   });
      document.onkeydown = function (e) {
          if (e.keyCode === 123) {
              return false
          }
          if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
              return false
          }
          if (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) {
              return false
          }
          if (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) {
              return false
          }
          if (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) {
              return false
          }
      }
  }, [])

  if (isLoading) {
      return <Loader />
  }

  return (
      <BrowserRouter>
          <EventContext.Provider value={handleEventLogs}>
              <Switch>
                  {authRoutes.map(({ path, Component, condition }) => (
                      <Route
                          key={path}
                          exact
                          path={path}
                          render={() => {
                              return condition(
                                  props.token,
                                  registration,
                                  registration_status,
                              ) ? (
                                  <Redirect to="/dashboard" />
                              ) : (
                                  <Component />
                              )
                          }}
                      />
                  ))}

                  {scholarshipRoutes.map(({ path, Component, condition }) => (
                      <Route
                          key={path}
                          exact
                          path={path}
                          render={() =>
                              condition(props.token) ? (
                                  <Redirect to="/dashboard" />
                              ) : (
                                  <Component />
                              )
                          }
                      />
                  ))}

                  <Route exact path="/dashboard" render={() => <Dashboard />} />

                  {publicRoutes.map(({ path, Component }) => (
                      <Route
                          key={path}
                          exact
                          path={path}
                          render={() => <Component />}
                      />
                  ))}
              </Switch>
          </EventContext.Provider>

          <ToastMessage
              isToastOpen={props.toastData.isToastOpen}
              toastType={props.toastData.toastType}
              toastMessage={props.toastData.toastMessage}
          />
      </BrowserRouter>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
